import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingOverlayService {
  private counter = 0;

  private minVisibleMs = 0;
  private shownAt = 0;

  readonly visible = signal(false);

  show(minVisibleMs = 0): void {
    this.counter++;

    if (!this.visible()) {
      this.minVisibleMs = minVisibleMs;
      this.shownAt = Date.now();
      this.visible.set(true);
    }
  }

  hide(): void {
    if (this.counter > 0) {
      this.counter--;
    }

    if (this.counter !== 0) {
      return;
    }

    const elapsed = Date.now() - this.shownAt;
    const remaining = Math.max(0, this.minVisibleMs - elapsed);

    setTimeout(() => {
      if (this.counter === 0) {
        this.visible.set(false);
      }
    }, remaining);
  }

  reset(): void {
    this.counter = 0;
    this.visible.set(false);
  }
}